import ajax from "nanoajax";
import { isHttpSuccess } from "../../../common/httpUtils"

export default (verificationToken, callback) => {
    const request = {
        url: "/disclosure/api/buyside-invitation/verify",
        method: 'POST',
        headers: { "Accept": "text/plain" },
        body: `token=${encodeURIComponent(verificationToken)}`
    };

    ajax.ajax(request, (statusCode, response) => {
        if (isHttpSuccess(statusCode)) {
            callback.success(response);
        }
        else {
            callback.failure(statusCode, response);
        }
    });
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/portal/actions/doVerifyToken.js
 **/